import { lazyRouteComponent } from '@tanstack/react-router';

export const termsPageLoadable = lazyRouteComponent(() =>
  import('../../ui/terms-page').then((m) => ({
    default: m.TermsPage,
  })),
);
